/**
 * Drop-in shim for the subset of `expo-clipboard` that Rinsepay uses.
 *
 * Only `setStringAsync(text)` is implemented, backed by
 * `@react-native-clipboard/clipboard` on native and the async Clipboard
 * API on web.
 *
 * Callers (admin/hardware-orders.tsx, owner/location/[id].tsx) wrap this
 * in a try/catch so failures degrade gracefully.
 */
import { Platform } from 'react-native';
import Clipboard from '@react-native-clipboard/clipboard';

export async function setStringAsync(text: string): Promise<void> {
  if (Platform.OS === 'web') {
    if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return;
    }
    throw new Error('Clipboard API unavailable');
  }
  Clipboard.setString(text);
}

export async function getStringAsync(): Promise<string> {
  if (Platform.OS === 'web') {
    if (typeof navigator !== 'undefined' && navigator.clipboard?.readText) {
      return navigator.clipboard.readText();
    }
    return '';
  }
  return Clipboard.getString();
}
